module.exports = __webpack_public_path__ + "files/0545316ef329fef4528b757739d42f57.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lora-italic-webfont.woff2
// module id = 852
// module chunks = 60